export enum ShipTimeStatus {
  FINISHED = 'finished',
  CALCULATING = 'calculating',
}
